import React from 'react';
import AppRoutes from '../../routes/routes';
import { ModalHeader, ModalStatusIcon } from '../popups/modal-parts';

export default class MarketingThanks extends React.Component {
    render() {
        return (
            <div className="modal-body is-centered">
                <ModalStatusIcon type="mail" />
                <ModalHeader
                    title="Check your inbox!"
                    sub="We've sent a confirmation link to your email. Please click it to activate your account and access the database."
                />
                <div className="modal-note">
                    <strong>Pro tip:</strong> Don't forget to check your junk or spam folder if the email doesn't
                    arrive in the next few minutes.
                </div>
                <p className="modal-footnote">
                    Still haven't received it? <a href={AppRoutes.contact}>Contact support</a>
                </p>
            </div>
        );
    }
}
